import { render, staticRenderFns } from "./ReviewPanel.vue?vue&type=template&id=74831578&"
import script from "./ReviewPanel.vue?vue&type=script&lang=js&"
export * from "./ReviewPanel.vue?vue&type=script&lang=js&"
import style0 from "./ReviewPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports